import { red } from "@mui/material/colors";
import PropTypes from "prop-types";
import React from "react";
import { useLocation } from "react-router-dom";
import Hub from "../components/Hub";
import HubList from "../components/HubList";

const measureCharts = [
  {
    type: "bloodpressure",
    label: "Blood Pressure",
    value: [
      {
        key: "systolic",
        color: "#8884d8",
        bounds: [{ color: red[500], value: 180 }, 141],
      },
      {
        key: "diastolic",
        color: "#82ca9d",
        bounds: [85],
      },
    ],
  },
  {
    type: "pulseox",
    label: "Pulseox",
    value: [
      {
        key: "spo2",
        color: "#123ec1",
        bounds: [81],
      },
      {
        key: "bpm",
        color: "#168e9d",
        bounds: [45, 120],
      },
    ],
  },
  {
    type: "temperature",
    label: "Temperature",
    value: [{ key: "celsius", color: "#BE4297", bounds: [96, 101.5] }],
  },
  {
    type: "weight",
    label: "Weight",
    value: [{ key: "weight_lbs", color: "#BE4111" }],
  },
];

export default function PressureCheck({ programId }) {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const hubId = queryParams.get("hub");

  return !hubId ? (
    <HubList programId={programId} measureCharts={measureCharts} isCKD />
  ) : (
    <Hub
      hubId={hubId}
      measureCharts={measureCharts}
      programId={programId}
      isCKD
    />
  );
}
PressureCheck.propTypes = {
  programId: PropTypes.string.isRequired,
};
